import { render, staticRenderFns } from "./CheckinsCard.vue?vue&type=template&id=455b80ec&scoped=true&"
import script from "./CheckinsCard.vue?vue&type=script&lang=js&"
export * from "./CheckinsCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "455b80ec",
  null
  
)

export default component.exports